/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ClientMessageEntityName;

(function (ClientMessageEntityName) {
  ClientMessageEntityName["QUOTE"] = "quote";
  ClientMessageEntityName["VALIDATION"] = "validation";
  ClientMessageEntityName["OTHER"] = "other";
})(ClientMessageEntityName || (ClientMessageEntityName = {}));